import React, { useEffect } from "react";
import { withNamespaces } from "react-i18next";
import { Card } from "react-bootstrap";
import DocumentTable from "./DocumentTable";
import { closeIframesScreens } from '~/containers/SidebarContainer/util';
import "~/assets/css/icons.css";

const DocumentManagement = ({ t, manager }) => {

  useEffect(() => {
    /*close full screen iframes*/
    closeIframesScreens();
  })

  return (
    <>
      <div className="main-card-v2">
        <Card
          bsPrefix="card-flat"
          style={{ minHeight: "80vh", overflow: "auto" }}
        >
          <Card.Header className="justify-content-between">
            <h6>{t("portalrh.documentManagement.title")}</h6>
          </Card.Header>
          <Card.Body>
            <DocumentTable manager={manager} />
          </Card.Body>
        </Card>
      </div>
    </>
  );
};
export default withNamespaces()(DocumentManagement);
